// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"50dc32af","297":"e1c186c8","328":"6d0b9ec4","495":"1034c5b1","530":"d8f5314b","610":"401e2117","787":"759b118c","852":"2a343894","893":"53f09435","895":"c39301e0"}[chunkId] + ".chunk.js";
};